import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_124: FaireProductEntity = {
  token: "legacy_prod_abbott-124",
  type: "product",
  name: "Beehive Honey Pot W Lid",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/469d853ad73e38565a51d6bb3311fcbc423bf2da7990523011b9fd7acc6bd700.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
